import React, {ChangeEventHandler, FC} from "react"
import Textarea from "../elements/Textarea";
import {useFormData} from "../../states/FormData";

const Step4: FC = () => {
      const { textWorkValue, setFormData } = useFormData()

    const handleTextareaChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => setFormData("textWorkValue", event.target.value)

    return (
        <div>
            <span className={"survey-heading"}>Hast du sonstige Fragen zum Thema Ernährung oder zu uns und unserer Arbeit?</span>
            <Textarea placeholder={"Ich würde gerne wissen..."} value={textWorkValue} onChange={handleTextareaChange} />
        </div>
    )
}
export default Step4